'use client'

import { useEffect, useRef, useState } from 'react'

import { Slot } from '@/shared/lib'
import { MobileHeader } from '@/widgets/common'

const HEADER_HEIGHT = 56

const IMAGE_ASPECT_WIDTH = 375
const IMAGE_ASPECT_HEIGHT = 280

const TABLET_IMAGE_HEIGHT = 320
const MD_BREAKPOINT = 768

const getScrollRange = () => {
  if (typeof window === 'undefined') {
    return IMAGE_ASPECT_HEIGHT - HEADER_HEIGHT
  }

  const isTablet = window.innerWidth >= MD_BREAKPOINT

  const imageHeight = isTablet
    ? TABLET_IMAGE_HEIGHT
    : (window.innerWidth * IMAGE_ASPECT_HEIGHT) / IMAGE_ASPECT_WIDTH

  return Math.max(imageHeight - HEADER_HEIGHT, 1)
}

type Props = {
  roomName: string
  onShared?: () => void
}

export const ScrollAwareHeader = ({ roomName, onShared }: Props) => {
  const [scrollProgress, setScrollProgress] = useState(0)
  const scrollRangeRef = useRef(getScrollRange())

  useEffect(() => {
    // 이미지 높이만큼 스크롤 하는 동안 헤더 색상이 투명에서 흰색으로 변경되도록 함
    const updateProgress = () => {
      const progress = Math.min(window.scrollY / scrollRangeRef.current, 1)

      setScrollProgress(progress)
    }

    const handleResize = () => {
      scrollRangeRef.current = getScrollRange()

      updateProgress()
    }

    updateProgress()
    window.addEventListener('scroll', updateProgress, { passive: true })
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('scroll', updateProgress)
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const bgOpacity = scrollProgress
  const iconValue = Math.round(255 * (1 - scrollProgress))

  return (
    <MobileHeader.Root
      className="z-sticky fixed top-0 right-0 left-0 bg-transparent"
      style={{
        backgroundColor: `rgba(255, 255, 255, ${bgOpacity})`,
      }}
    >
      <Slot name="left">
        <MobileHeader.Back
          style={{
            color: `rgb(${iconValue}, ${iconValue}, ${iconValue})`,
          }}
        />
      </Slot>
      <Slot name="right">
        <MobileHeader.Share
          title={roomName}
          onShared={onShared}
          style={{
            color: `rgb(${iconValue}, ${iconValue}, ${iconValue})`,
          }}
        />
      </Slot>
    </MobileHeader.Root>
  )
}
